import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';

import {
  LISTING_SERVICE_OPTION_ITEMS,
} from 'common/listingConstants';

import SrUserSettingDropdown from 'client/components/SrUserSettingDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import UserActions from 'client/actions/User';

const options = [
  {
    label: 'All',
    value: undefined,
  },
  ...LISTING_SERVICE_OPTION_ITEMS,
];

class SrUserSettingListingServicesDropdown extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    settingField: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      settingValue: getIn(props.currentUser.settings, props.settingField),
    };
  }

  _onUpdateSetting = (listingStatus) => {
    const { settingValue } = this.state;

    // User selects "all"
    if (listingStatus === undefined) {
      this.setState({ settingValue: undefined });
    }
    // User selects a different status and the current option is "all"
    else if (settingValue === undefined) {
      this.setState({ settingValue: [listingStatus] });
    }
    else {
      this.setState({
        settingValue: settingValue.includes(listingStatus)
          ? settingValue.filter((option) => option !== listingStatus)
          : [...settingValue, listingStatus],
      });
    }
  }

  _onSaveSettings = () => {
    const { currentUser, settingField, dispatch } = this.props;
    const { settingValue } = this.state;
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, settingValue);
    dispatch(UserActions.updateSettings, newUserSettings);
  }

  render() {
    const {
      currentUser,
      settingField,
      dispatch,
    } = this.props;

    const {
      settingValue,
    } = this.state;

    const settingValueArray = Array.isArray(settingValue)
      ? settingValue
      : [settingValue];

    const optionsActive = options
      .filter((option) => settingValueArray.includes(option.value))
      .map(({ label }) => label)
      .join(', ');
    const title = `Listing Type: ${optionsActive || 'All'}`;

    return (
      <SrUserSettingDropdown
        user={currentUser}
        settingField={settingField}
        settingValue={settingValue}
        title={title}
        options={options}
        onChange={this._onUpdateSetting}
        dispatch={dispatch}
        shouldUpdateSettings={false}
        multiple
        footer={(
          <div className='buttonContainer'>
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE}
              type='button'
              onClick={this._onSaveSettings}
            >
              save
            </ButtonDeprecated>
          </div>
        )}
      />
    );
  }
}

SrUserSettingListingServicesDropdown.displayName = 'SrUserSettingListingServicesDropdown';

export default SrUserSettingListingServicesDropdown;
